import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const PlayerEntryPage = () => {
  const [code, setCode] = useState('');
  const navigate = useNavigate();

  const handleDigit = (digit: string) => {
    if (code.length >= 5) return;
    const next = code + digit;
    setCode(next);
    if (next.length === 5) {
      setTimeout(() => navigate(`/tv/${next}`), 120);
    }
  };

  const handleBack = () => setCode(prev => prev.slice(0, -1));

  const digits = [1, 2, 3, 4, 5, 6, 7, 8, 9, null, 0, 'del'] as const;

  return (
    <div style={styles.root}>
      <div style={styles.card}>
        <div style={styles.logo}>ThBA Mídia</div>
        <p style={styles.subtitle}>Digite o código da playlist</p>

        <div style={styles.codeDisplay}>
          {Array.from({ length: 5 }).map((_, i) => (
            <div
              key={i}
              style={{
                ...styles.codeBox,
                ...(code[i] ? styles.codeBoxFilled : {}),
                ...(i === code.length ? styles.codeBoxActive : {}),
              }}
            >
              {code[i] ?? ''}
            </div>
          ))}
        </div>

        <div style={styles.numpad}>
          {digits.map((d, i) => {
            if (d === null) return <div key={i} />;
            if (d === 'del') return (
              <button key={i} style={{ ...styles.btn, ...styles.btnDel }} onClick={handleBack}>
                ⌫
              </button>
            );
            return (
              <button
                key={i}
                style={styles.btn}
                onClick={() => handleDigit(String(d))}
              >
                {d}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  root: {
    minHeight: '100vh',
    background: '#0a0f1a',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: "'Inter', sans-serif",
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 24,
  },
  logo: {
    fontSize: 32,
    fontWeight: 700,
    color: '#14b8a0',
    letterSpacing: '-0.5px',
  },
  subtitle: {
    fontSize: 18,
    color: '#94a3b8',
    margin: 0,
  },
  codeDisplay: {
    display: 'flex',
    gap: 12,
    marginBottom: 8,
  },
  codeBox: {
    width: 56,
    height: 72,
    borderRadius: 10,
    border: '2px solid #1e293b',
    background: '#0f172a',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 36,
    fontWeight: 700,
    color: '#f1f5f9',
    transition: 'border-color 0.15s',
  },
  codeBoxFilled: {
    border: '2px solid #14b8a0',
  },
  codeBoxActive: {
    border: '2px solid #38bdf8',
    boxShadow: '0 0 0 3px rgba(56,189,248,0.2)',
  },
  numpad: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 80px)',
    gap: 12,
  },
  btn: {
    height: 72,
    borderRadius: 12,
    border: 'none',
    background: '#1e293b',
    color: '#f1f5f9',
    fontSize: 26,
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'background 0.12s',
  },
  btnDel: {
    background: '#1e2d3d',
    color: '#94a3b8',
    fontSize: 22,
  },
};

export default PlayerEntryPage;
